<script>
  export let handler
  export let loading
  export let signup
  let email
  let password

  const callHandler = async() => {
    handler(email, password)
  }

</script>

<div class="w-full max-w-xs">
  <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" on:submit|preventDefault={callHandler}>
    <h2 class="text-blue-500 text-xl mb-5">{signup ? "Sign Up" : "Sign In"}</h2>
    <div class="mb-4">
      <label for="email" class="block text-gray-700 text-sm font-bold mb-2">Email</label>
      <input
	id="email"
        class="inputFieldshadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        type="email"
        placeholder="email"
        bind:value={email}
	/>
    </div>
    <div class="mb-6">
      <label for="password" class="block text-gray-700 text-sm font-bold mb-2">Password</label>
      <input
	id="password"
        class="inputFieldshadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        type="password"
        placeholder="password"
        bind:value={password}
	/>
    </div>
    <div class="flex items-center justify-between">
      <input type="submit" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" value={loading ? "Loading" : (signup ? "Sign Up" : "Sign In")} disabled={loading} />
    </div>
    <br/><br/>
    {#if signup}
      <a class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800" href="/sign-in">
        Already have an account?
      </a><br />
    {:else}
      <a class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800" href="/forgot-password">
        Forgot password?
      </a><br />
      <a class="inline-block align-baseline font-bold text-sm text-blue-500 hover:text-blue-800" href="/sign-up">
        Need an account?
      </a>
    {/if}
  </form>
</div>
